import { createContext, useContext } from "react";

// The context object lives in its own module that imports only React. contex.js imports the mind-map library, so
// it re-runs on every hot reload of a library file; creating the context there gave consumers a different object
// than the provider ("Cannot destructure ... of MindMapContext() as it is undefined" in the dev server).
export const MapContext = createContext();

export const MindMapContext = () => {
  return useContext(MapContext);
};
